// extracted by mini-css-extract-plugin
module.exports = {"team-item":"_3onpLluqcqMYc05t0EyN","content":"_35kAXX3CcTQAXh7ffyjf","team-name":"_8bl_X9WtSW5wSvKf5rK1"};